<script setup lang="ts">
import { isValidString } from "@/Utils/String";

export interface ErrorMessageProps {
  message?: string;
}

const props = defineProps<ErrorMessageProps>();
</script>

<template>
  <div class="error-message">
    <slot>
      <p v-if="isValidString($props.message)">{{ props.message }}</p>
    </slot>
  </div>
</template>

<style lang="scss" scoped>
.error-message {
  @include sp.padding(false, 4);
  @include text.general(low, m);
  @include colors.bg(semantic, error);
  @include colors.color(content, inverse);

  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
}
</style>
